"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getColGap = function (colGap, cols, size) {
    if (cols && colGap) {
        if (size in cols && colGap[size] === 'columnWidth') {
            return "calc(100% * ( 1 / (".concat(cols[size], " * 2)))");
        }
        if (size in colGap) {
            return colGap[size];
        }
    }
    return '0px';
};
exports.default = getColGap;
//# sourceMappingURL=getColGap.js.map